<!-- 
  组件描述： 弹窗组件
  组件参数: 
  show: 是否显示弹窗
  width: 弹窗宽度
  showClose: 是否显示关闭按钮
  btnObj: 弹窗底部按钮配置
  cancel: 取消按钮回调
  save: 确认按钮回调
  close: 关闭按钮回调
  组件封装人： fqq
  组件封装时间： 2025-05-9
 -->
<template>
  <div
    v-if="show"
    class="my-dialog-box"
    @click.self="
      () => {
        isBlankClose ? close() : '';
      }
    "
  >
    <div
      :style="{ width: _width }"
      :class="[customClassName]"
      class="my-dialog"
    >
      <slot name="all">
        <div class="dialog-title">
          <slot name="title"></slot>
          <el-icon
            v-if="showClose"
            class="hoverPointer"
            @click="close"
            font-size="1rem"
            ><Close></Close>
          </el-icon>
        </div>
        <div class="dialog-content">
          <el-scrollbar>
            <slot name="content"></slot>
          </el-scrollbar>
        </div>
        <div :class="{ marginTop: _btnObj.showFooter }" class="dialog-footer">
          <slot name="footer"></slot>

          <template v-if="_btnObj.showFooter">
            <el-button
              v-if="_btnObj.showCancel"
              :class="_btnObj.cancelClass"
              @click="cancel"
              round
            >
              {{ _btnObj.cancelText }}
            </el-button>
            <el-button
              v-if="_btnObj.showSave"
              :class="_btnObj.saveClass"
              type="primary"
              @click="save"
              round
              class="save"
              :loading="_loading"
            >
              {{ _btnObj.saveText }}
            </el-button>
          </template>
        </div>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, defineProps, computed } from "vue";
import { Close } from "@element-plus/icons-vue";

// props
const props = defineProps({
  width: {
    default: "25rem",
  },
  modelValue: {
    default: false,
  },
  btnObj: {
    default: {},
    type: Object,
  },
  loading: {
    default: false,
    type: Boolean,
  },
  showClose: {
    default: false,
    type: Boolean,
  },
  customClassName: {
    default: "",
    type: String,
  },
  isBlankClose: {
    default: false,
    type: Boolean,
  },
});
const _btnObj = computed(() => {
  let btn = {
    ...{
      showFooter: true,
      cancelText: "Cancel",
      showCancel: true,
      cancelClass: "",
      saveText: "Confirm",
      showSave: true,
      saveClass: "",
    },
    ...props.btnObj,
  };
  return btn;
});

const _width = computed(() => {
  return props.width instanceof Number ? props.width + "px" : props.width;
});
// 是否显示加载
const _loading = computed(() => props.loading);
// 是否显示弹窗
const show = defineModel(
  () => props.modelValue,
  (value) => emit("update:modelValue", value)
);
// emits
const emits = defineEmits(["save", "cancel", "close"]);

// 点击保存按钮
function save() {
  emits("save");
}

// 点击取消按钮
function cancel() {
  show.value = false;
  emits("cancel");
  emits("close");
}

// 点击关闭按钮
function close() {
  show.value = false;
  emits("closeIcon");
}

onMounted(() => {});

onUnmounted(() => {});
</script>

<style lang="scss" scoped>
.my-dialog-box {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2100;

  .my-dialog {
    padding: 30px;
    width: 200px;
    max-width: 1200px;
    max-height: 75vh;
    background: #fff;
    border-radius: 20px;
    display: flex;
    flex-direction: column;

    .dialog-title {
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: font-size(dialogTitle);
      font-weight: 600;
      color: #202020;
    }

    .dialog-content {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .el-scrollbar {
        flex: 1;
        display: flex;
        flex-direction: column;
        .el-scrollbar__wrap {
          flex: 1;
          overflow: auto;
        }
      }
    }

    .dialog-footer {
      display: flex;
      justify-content: flex-end;

      &.marginTop {
        margin-top: 30px;
      }

      .el-button {
        height: other-size(heightInput);
        line-height: other-size(heightInput);
        border-radius: 12px;
        opacity: 1;
        text-align: center;
        padding: 0 24px;
        min-width: 140px;
        font-size: font-size(formL);
        font-weight: 600;
      }
    }
  }
}
</style>
